/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./goldcoinIndex.vue?vue&type=template&id=5ea8c1da&scoped=true"
import script from "./goldcoinIndex.vue?vue&type=script&lang=js"
export * from "./goldcoinIndex.vue?vue&type=script&lang=js"
import style0 from "./goldcoinIndex.vue?vue&type=style&index=0&id=5ea8c1da&prod&lang=scss"
import style1 from "./goldcoinIndex.vue?vue&type=style&index=1&id=5ea8c1da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea8c1da",
  null
  
)

export default component.exports